<template>
  <div id="social-providers">
    <Telegram @auth="telegramAuth" class="mt-3" />
    <div v-if="ff_socialsList">
      <button
        v-for="provider in providers"
        :key="provider"
        class="social-link-button"
        @click="socialLogin(provider)"
      >
        <img :src="getAsset(provider)" :alt="provider" />
      </button>
    </div>
  </div>
</template>

<script>
import Telegram from './Telegram'

const providers = ['google', 'facebook', 'vk']
// Do such array to prevent build warnings
const providersAssets = {
  google: require(`@/assets/socials/google.svg`),
  facebook: require(`@/assets/socials/facebook.svg`),
  vk: require(`@/assets/socials/vk.svg`),
}

export default {
  data() {
    return {
      providers,
      ff_socialsList: false,
    }
  },
  methods: {
    socialLogin(provider) {
      location.href = `${process.env.VUE_APP_BACKOFFICE_URL}connect/${provider}`
    },
    getAsset(provider) {
      return providersAssets[provider]
    },
    telegramAuth(user) {
      this.$emit('telegramAuth', user)
    },
  },
  components: {
    Telegram,
  },
}
</script>

<style lang="scss">
$socialsize: 48px;
.authbox .social-link-button {
  height: $socialsize;
  width: $socialsize;
  border-radius: 50%;
  background: #ffffff;
  border: 1px solid #eaeaf5;

  &:not(:last-child) {
    margin: 0 20px 0 0;
  }

  img {
    vertical-align: middle;
  }

  @media (max-width: 500px) {
    $socialsize: 32px;
    height: $socialsize;
    width: $socialsize;

    &:not(:last-child) {
      margin: 0 32px 0 0;
    }

    img {
      max-width: 90%;
      max-height: 70%;
      vertical-align: middle;
    }
  }
}
</style>
